import { CRUD } from "@/shared/components";
import {
  DeleteContentsMutation,
  RestoreContentsMutation,
} from "@/admin/entities/contents";
import { ContentShow } from "@/admin/features/contents";
import { StreamsListQuery } from "@/admin/entities/streams";
import { useStreamsManagement, type StreamRow, StreamsSchemas } from "../model";

/**
 * Реестр эфиров: тот же Query.contents, что и раздел «Контент», но с
 * зашитым type=STREAM и колонками самого эфира. Только просмотр и
 * удаление/восстановление — редактирования нет.
 */
export function Streams() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useStreamsManagement();

  return (
    <CRUD<StreamRow>
      listQuery={StreamsListQuery}
      listQueryVariables={{ filter: { type: "STREAM" } }}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={StreamsSchemas.filterSchema}
      editSchema={{
        ...StreamsSchemas.editSchema,
        details: {
          ...StreamsSchemas.editSchema.details,
          showComponent: ContentShow,
        },
      }}
      deleteMutation={DeleteContentsMutation}
      restoreMutation={RestoreContentsMutation}
      texts={texts}
      persistFilters
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
